<template>
  <div class="layout">
    <!-- Loader pendant bootstrap auth ou si non authentifié -->
    <div v-if="authStore.loading || !authStore.isAuthenticated" class="layout__loader">
      Chargement…
    </div>

    <!-- Layout principal (seulement si auth ready ET authentifié) -->
    <template v-else>
      <!-- Desktop Sidebar -->
      <MainSidebar
        class="hide-mobile"
        :compact="!sidebarExpanded"
        @mouseenter="sidebarExpanded = true"
        @mouseleave="sidebarExpanded = false"
      />

      <div class="layout__content">
        <!-- Mobile Topbar -->
        <MobileAppTopbar
          @user-menu-click="showUserMenu = true"
          @main-menu-click="showMainMenu = true"
        />

        <!-- Content -->
        <slot />

        <!-- Mobile Menus -->
        <MainMenuMobile
          v-model="showMainMenu"
        />
        <UserMenuMobile
          v-model="showUserMenu"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import MainSidebar from '@/components/sidebar/MainSidebar.vue'
import MainMenuMobile from '@/components/menu/MainMenuMobile.vue'
import UserMenuMobile from '@/components/menu/UserMenuMobile.vue'
import MobileAppTopbar from '@/components/menu/MobileAppTopbar.vue'

const authStore = useAuthStore()
const sidebarExpanded = ref(false)
const showMainMenu = ref(false)
const showUserMenu = ref(false)
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
}

.layout__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: auto;
  margin-top: 48px;
}

@media screen and (min-width: 768px) {
  .layout__content {
    margin-left: 56px;
    margin-top: 0px;
  }
}

/* Mobile Topbar */
.mobile-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: white;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 10;
}

.mobile-topbar__logo {
  height: 2rem;
}

.mobile-topbar__actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.mobile-topbar__button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: none;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}

.mobile-topbar__button:hover {
  background: #f3f4f6;
}

.mobile-topbar__username {
  font-size: 0.875rem;
  display: none;
}

/* Désactiver le scroll élastique et pull-to-refresh sur iOS et Android */
html, body {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overscroll-behavior-y: none;
  -webkit-overscroll-behavior-y: none;
  touch-action: none;
  -ms-touch-action: none;
  -webkit-overflow-scrolling: touch;
}

.q-layout {
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: none;
  -webkit-overscroll-behavior-y: none;
  touch-action: pan-y pinch-zoom;
  -ms-touch-action: pan-y pinch-zoom;
}
</style>